import { forwardRef, type Ref, type SVGProps } from "react";
const IconShoppingOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M18 6v1h-2.953a1 1 0 0 0-1 1.045L14.32 14H13v-1a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v1H3.074a1 1 0 0 0-.997 1.071l.413 5.787q.01.142 0 .284l-.413 5.787A1 1 0 0 0 3.074 28h12.852a1 1 0 0 0 .998-1.071L16.857 26h12.079a1 1 0 0 0 .998-1.062L29.5 18l.453-9.955a1 1 0 0 0-1-1.045H26V6a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3M6 16v1a1 1 0 1 0 2 0v-1h3v1a1 1 0 1 0 2 0v-1h1.852l-.336 4.715q-.021.285 0 .57L14.852 26H4.148l.337-4.715q.021-.285 0-.57L4.148 16zm5-2H8v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zm5.924 1.071a1 1 0 0 0-.6-.989L16.094 9H18v1a1 1 0 1 0 2 0V9h4v1a1 1 0 1 0 2 0V9h1.907l-.41 9.017.375 5.983H16.715l-.204-2.858a2 2 0 0 1 0-.284zM21 5a1 1 0 0 0-1 1v1h4V6a1 1 0 0 0-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconShoppingOutlineSVG);
ForwardRef.displayName = "IconShoppingOutline";
export { ForwardRef as IconShoppingOutline };
